// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ex5u","col":"styles_col__39si8"};